export const HOME = "/home";
export const CUSTOM_HOME = "/";

export const ABOUT = "/about";

export const SUPPORTUS = "/support-us";

export const SCHEDULE = "/schedule";
